import * as React from "react";

import { GridItem, GridRoot } from "./GridRow.styles";

interface GridRowProps {
    children: React.ReactNode;
    className?: string;
}

export function GridRow(props: GridRowProps): JSX.Element {
    return <GridRoot className={props.className}>{props.children}</GridRoot>;
}

interface GridColProps {
    allCols: number;
    cols: number;
    className?: string;
    vertical?: "bottom";
    children: React.ReactNode;
}

export function GridCol(props: GridColProps): JSX.Element {
    return (
        <GridItem
            className={props.className}
            widthUnits={props.cols}
            totalUnits={props.allCols}
            alignBottom={props.vertical === "bottom"}>
            {props.children}
        </GridItem>
    );
}
